import { render, staticRenderFns } from "./publicView.vue?vue&type=template&id=01249556&scoped=true&"
import script from "./publicView.vue?vue&type=script&lang=js&"
export * from "./publicView.vue?vue&type=script&lang=js&"
import style0 from "./publicView.vue?vue&type=style&index=0&id=01249556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01249556",
  null
  
)

export default component.exports